//ここがrootのページの頭を作ってる

import React from "react";
import PropTypes from "prop-types";

import top1 from "../../images/png/IMG_0866.jpg";
import top2 from "../../images/png/_MG_1590.jpg";
import top3 from "../../images/png/rc20.jpg";
import top4 from "../../images/png/IMG_2585.jpg";
import { Link } from "gatsby";

const Hero = props => {
  const { backgrounds, theme, pathPrefix } = props;

  return (
    <React.Fragment>
      <section className="cd-hero">
        <img src={top1} loading="lazy" />
        <img src={top2} loading="lazy" />
        <img src={top3} loading="lazy" />
        <img src={top4} loading="lazy" />
      </section>
      <article className="cd-main">
        <div className="container">
          <div className="row">
            <div className="col-10 offset-1">
              <h2 data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
                About
              </h2>
              <p>
                <b>RoboTech</b> は <b>東京大学のロボコンサークル</b>です。NHK 学生ロボコン・ ABU
                アジア太平洋ロボットコンテストでの優勝を目指してロボットを製作しています。
                創立から約 20 年の歴史の中で、NHK学生ロボコンでは6度優勝し、さらに ABU
                ロボコン大賞世界最多受賞という実績を上げることができました。
              </p>
              <h4 className="text-center">これからも私たちの飽くなき挑戦は続きます。</h4>
            </div>
            <div className="col-10 offset-1 text-center">
              <Link to="/about">
                <button className="robo-button">About</button>
              </Link>
            </div>
            <div className="col-10 offset-1">
              <h2 data-sal="slide-up" data-sal-duration="1000" data-sal-easing="ease">
                Join Us
              </h2>
              <p>
                新歓イベント等を開催予定ですので、入部を希望される方は奮ってご参加ください。
              </p>
            </div>
            <div className="col-10 offset-1 text-center">
              <Link to="/joinus">
                <button className="robo-button">Join Us</button>
              </Link>
            </div>
          </div>
        </div>
      </article>
      {/* --- STYLES --- each theme color is defined at theme.yaml*/}
      <style jsx>{`
        .cd-main {
          .robo-button {
            background-color: #009fc5;
            color: white;
            font-size: 30px;
            font-weight: bold;
            padding: 5px 30px;
            border: none;
            position: relative;
            margin-top: 20px;
            margin-bottom: 90px;

            &::before {
              transition: all 0.2s;
              position: absolute;
              display: block;
              content: "";
              width: 100%;
              height: 100%;
              top: 20%;
              left: 10%;
              background: #fdcc0f;
              z-index: -1;
            }

            &:hover::before {
              transform: translate(-20%, 0);
            }

            &:active::before {
              transform: translate(-20%, 20%);
            }
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            padding-left: 10px;
            padding-right: 10px;
          }

          p {
            font-size: 1.1em;
            line-height: 1.6;
          }

          h2 {
            border-left: none !important;
            position: relative;
            padding-left: 48px;
            margin-bottom: 20px;
            //font-weight: bold;
            font-size: 40px;

            &::before,
            &::after {
              position: absolute;
              display: block;
              content: "";
            }

            &::after {
              width: 28px;
              height: 28px;
              top: 7px;
              left: 0;
              background: #009fc5;
            }

            &::before {
              width: 20px;
              height: 20px;
              top: 22px;
              left: 16px;
              background: #fdcc0f;
            }
          }
        }

        .cd-hero {
          display: table;
          width: 100vw;
          margin-top: 100px;
          margin-bottom: 100px;
          height: 400px;
          position: relative;

          .cd-hero-content {
            width: 350px;
            height: 50px;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            text-align: center;
            line-height: 50px;
            font-size: 70px;
            font-weight: bold;
            text-shadow: 1px 2px 10px #808080;
            color: white;
            z-index: 1;
          }

          img {
            width: 110% !important;
            height: 100%;
            object-fit: cover;
            position: absolute;
            animation: slideAnime 28s ease infinite;
            max-width: none;
            opacity: 0;
          }

          img:nth-of-type(1) {
            animation-delay: 0s;
          }

          img:nth-of-type(2) {
            animation-delay: 7s;
          }

          img:nth-of-type(3) {
            animation-delay: 14s;
          }

          img:nth-of-type(4) {
            animation-delay: 21s;
          }
        }

        @media (min-width: 1140px) {
          .cd-hero {
            height: 600px;
            margin-bottom: 50px;
          }
        }

        @media (max-width: 1140px) {
          .cd-hero {
            height: 400px;
            margin-bottom: 50px;
          }
        }

        @media (max-width: 576px) {
          .cd-hero {
            height: 250px;
            margin-bottom: 50px;
          }
        }

        @keyframes slideAnime {
          0% {
            opacity: 0;
            transform: translateX(-2.5%);
          }
          12% {
            opacity: 1;
          }
          25% {
            opacity: 1;
          }
          37% {
            opacity: 0;
          }
          100% {
            opacity: 0;
            transform: translateX(2.5%);
          }
        }
      `}</style>
    </React.Fragment>
  );
};

Hero.propTypes = {
  backgrounds: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  pathPrefix: PropTypes.string.isRequired
};

export default Hero;
